  document.addEventListener("DOMContentLoaded", () => {
    const input = document.getElementById("text-search") as HTMLInputElement;
    if (!input) return;

    const filterContent = () => {
      const filterString = input.value.toLowerCase()
      document.querySelectorAll(".jsFilterable").forEach((item: Element) => {
        if (filterString && item.textContent?.toLowerCase().indexOf(filterString) === -1) {
          item.classList.add("d-none")
        } else {
          item.classList.remove("d-none")
        }
      })
    }

    let timer: ReturnType<typeof setTimeout>;

    const handleKeyUp = () => {
      clearTimeout(timer);
      timer = setTimeout(filterContent, 800);
    }

    input.addEventListener("keyup", handleKeyUp);
  })
